class QuickAddForm extends HTMLElement {
  connectedCallback() {
    if (this.bound) return; // element reconnects when the modal is moved/swapped
    this.sizeButtons = Array.from(this.querySelectorAll('[data-variant-id]'));
    this.quickBuy = this.querySelector('quick-buy');
    this.submitButton = this.quickBuy?.querySelector('button');
    this.submitLabel = this.submitButton?.querySelector('[data-submit-label]');
    this.selectedSize = this.querySelector('[data-selected-size]');
    this.selectedValue = this.querySelector('[data-selected-value]');
    this.selectedIndicator = this.querySelector('[data-selected-indicator]');
    this.notifyMode = false;

    if (!this.sizeButtons.length || !this.submitButton) return;
    this.bound = true;

    for (const button of this.sizeButtons) {
      button.addEventListener('click', this.onSizeClick.bind(this));
    }
    this.submitButton.addEventListener('click', this.onSubmitClick.bind(this));
  }

  onSizeClick(event) {
    const selected = event.currentTarget;
    this.notifyMode = selected.dataset.notify !== undefined;

    for (const button of this.sizeButtons) {
      button.classList.toggle('is-active', button === selected);
    }

    if (this.notifyMode) {
      this.quickBuy.removeAttribute('variant-ids'); // keeps quick-buy inert on click
    } else {
      this.quickBuy.setAttribute('variant-ids', selected.dataset.variantId);
    }
    this.submitButton.dataset.variantId = selected.dataset.variantId; // BIS drawer pre-selects from its trigger
    this.submitButton.removeAttribute('disabled');
    this.submitLabel.textContent = this.notifyMode
      ? this.submitButton.dataset.bisLabel
      : this.submitButton.dataset.atcLabel;

    if (this.selectedValue) this.selectedValue.textContent = selected.dataset.optionValue;
    if (this.selectedIndicator) {
      let indicator = '';
      if (this.notifyMode) {
        indicator = this.dataset.labelSoldOut;
      } else if (selected.dataset.lowStock !== undefined) {
        indicator = this.dataset.labelLowStock;
      }
      this.selectedIndicator.textContent = indicator;
    }
    if (this.selectedSize) this.selectedSize.hidden = false;
  }

  onSubmitClick() {
    if (!this.notifyMode) return; // available variant: quick-buy owns the click
    // close the pop-up first (mirrors add-to-cart), so notify opens over a single overlay
    this.closest('modal-dialog')?.hide();
    document.querySelector('#global-bis-drawer')?.open(this.submitButton);
  }
}

if (!customElements.get('quick-add-form')) {
  customElements.define('quick-add-form', QuickAddForm);
}
